import SC from "../constants/AmuletStackerConstants"

export const initialState = {
  chain: {},
  products: [],
  status: "None",
}

export default function stackerReducer(previousState = initialState, action) {
  switch (action.type) {
    case SC.CHAIN_LOAD_PENDING:
      return {
        ...previousState,
        ...action.payload,
        status: SC.CHAIN_LOAD_PENDING,
      }
    case SC.CHAIN_LOAD_COMPLETE:
      return {
        ...previousState,
        ...action.payload,
        status: SC.CHAIN_LOAD_COMPLETE,
      }
    case SC.RESET_CHAIN:
      return initialState
    case SC.SELECT_CHAIN:
      return { ...previousState, chain: action.payload }
    default:
      return previousState
  }
}
